import { format } from 'd3-format';
import { isNil } from 'ramda';

import { formatDate } from 'helpers/date';
import { BatchConfigData } from 'scenes/Report/scenes/BatchReport/BatchReport.config';

const ReplaceTextConfig: BatchConfigData[] = [
  {
    defaultValue: null,
    containsText: '{{__cashbackPercent__}}',
    path: 'segmentValue',
    formatter: (value: number) =>
      isNil(value) ? 'Combined Report' : `${format(',.0f')(value)}% Cash Back`,
  },
  {
    defaultValue: null,
    containsText: '{{__segmentId__}}',
    path: 'segmentValue',
    formatter: (value: string) => (value === null ? 'Combined Report' : value),
  },
  {
    defaultValue: 0,
    containsText: '{{__startDate__}}',
    path: 'startDate',
    formatter: (date: string) => formatDate(date, 'MM/DD/YY'),
  },
  {
    defaultValue: 0,
    containsText: '{{__endDate__}}',
    path: 'endDate',
    formatter: (date: string) => formatDate(date, 'MM/DD/YY'),
  },
];

export default ReplaceTextConfig;
